'use client';

import { c as _c } from "react/compiler-runtime";
import type { MouseEvent, Ref } from 'react';
import { useAuthStore } from '@/entities/auth';
import { useLanguage } from '@/features/language';
import { ENV } from '@/shared/config';
import { getHostOrigin } from '@/shared/lib/path';
import { login } from '@/shared/utils';
import { useTranslations } from 'next-intl';
import { useRouter } from 'next/navigation';
import { getVtonImageUrl } from '@/pages/intro/lib/vton-image-url';
import styles from './ResultView.module.scss';
interface ResultViewProps {
  imageSrc: string;
  onRetry: () => void;
  isFallback?: boolean;
  ref?: Ref<HTMLDivElement>;
}
export const ResultView = t0 => {
  const $ = _c(62);
  const {
    imageSrc,
    onRetry,
    isFallback: t1,
    ref
  } = t0;
  const isFallback = t1 === undefined ? false : t1;
  const t = useTranslations("intro");
  const router = useRouter();
  const [locale] = useLanguage();
  const isAuthenticated = useAuthStore(_temp);
  let t2;
  if ($[0] !== isAuthenticated || $[1] !== locale || $[2] !== router) {
    t2 = () => {
      const productsPath = `/${locale}/products`;
      if (isAuthenticated) {
        router.push(productsPath);
        return;
      }
      login(ENV.AUTH_API_BASE_URL, `${getHostOrigin()}${productsPath}`);
    };
    $[0] = isAuthenticated;
    $[1] = locale;
    $[2] = router;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const handleLoginRedirect = t2;
  let t3;
  if ($[4] !== onRetry) {
    t3 = _event => {
      onRetry();
    };
    $[4] = onRetry;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const handleRetry = t3;
  let t4;
  if ($[6] !== imageSrc) {
    t4 = getVtonImageUrl(imageSrc);
    $[6] = imageSrc;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t) {
    t5 = t("aiExperience.result.imageAlt");
    $[8] = t;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t4 || $[11] !== t5) {
    t6 = <img src={t4} alt={t5} className={styles.image} />;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== isFallback || $[14] !== t) {
    t7 = isFallback ? <span className={styles.fallbackBadge}>{t("aiExperience.result.fallbackBadge")}</span> : null;
    $[13] = isFallback;
    $[14] = t;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t6 || $[17] !== t7) {
    t8 = <div className={styles.imageColumn}><div className={styles.imageWrap}>{t6}{t7}</div></div>;
    $[16] = t6;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== t) {
    t9 = t("aiExperience.result.headline1");
    $[19] = t;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== t9) {
    t10 = <p className={styles.headlineLine}>{t9}</p>;
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== t) {
    t11 = t("aiExperience.result.headline2");
    $[23] = t;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== t11) {
    t12 = <p className={styles.headlineLine}>{t11}</p>;
    $[25] = t11;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== t10 || $[28] !== t12) {
    t13 = <div className={styles.headline}>{t10}{t12}</div>;
    $[27] = t10;
    $[28] = t12;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  let t14;
  if ($[30] !== t) {
    t14 = t("aiExperience.result.subhead");
    $[30] = t;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  let t15;
  if ($[32] !== t14) {
    t15 = <p className={styles.subheadLine}>{t14}</p>;
    $[32] = t14;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  let t16;
  if ($[34] !== t) {
    t16 = t("aiExperience.result.subheadAccent");
    $[34] = t;
    $[35] = t16;
  } else {
    t16 = $[35];
  }
  let t17;
  if ($[36] !== t16) {
    t17 = <p className={styles.subheadAccent}>{t16}</p>;
    $[36] = t16;
    $[37] = t17;
  } else {
    t17 = $[37];
  }
  let t18;
  if ($[38] !== t15 || $[39] !== t17) {
    t18 = <div className={styles.subhead}>{t15}{t17}</div>;
    $[38] = t15;
    $[39] = t17;
    $[40] = t18;
  } else {
    t18 = $[40];
  }
  let t19;
  if ($[41] !== t) {
    t19 = t("aiExperience.result.primary");
    $[41] = t;
    $[42] = t19;
  } else {
    t19 = $[42];
  }
  let t20;
  if ($[43] !== handleLoginRedirect || $[44] !== t19) {
    t20 = <button type="button" onClick={handleLoginRedirect} className={`${styles.button} ${styles.buttonPrimary}`}>{t19}</button>;
    $[43] = handleLoginRedirect;
    $[44] = t19;
    $[45] = t20;
  } else {
    t20 = $[45];
  }
  let t21;
  if ($[46] !== t) {
    t21 = t("aiExperience.result.retry");
    $[46] = t;
    $[47] = t21;
  } else {
    t21 = $[47];
  }
  let t22;
  if ($[48] !== handleRetry || $[49] !== t21) {
    t22 = <button type="button" onClick={handleRetry} className={`${styles.button} ${styles.buttonSecondary}`}>{t21}</button>;
    $[48] = handleRetry;
    $[49] = t21;
    $[50] = t22;
  } else {
    t22 = $[50];
  }
  let t23;
  if ($[51] !== t20 || $[52] !== t22) {
    t23 = <div className={styles.buttonRow}>{t20}{t22}</div>;
    $[51] = t20;
    $[52] = t22;
    $[53] = t23;
  } else {
    t23 = $[53];
  }
  let t24;
  if ($[54] !== t13 || $[55] !== t18 || $[56] !== t23) {
    t24 = <div className={styles.actionsColumn}>{t13}{t18}{t23}</div>;
    $[54] = t13;
    $[55] = t18;
    $[56] = t23;
    $[57] = t24;
  } else {
    t24 = $[57];
  }
  let t25;
  if ($[58] !== ref || $[59] !== t24 || $[60] !== t8) {
    t25 = <div ref={ref} className={styles.container}>{t8}{t24}</div>;
    $[58] = ref;
    $[59] = t24;
    $[60] = t8;
    $[61] = t25;
  } else {
    t25 = $[61];
  }
  return t25;
};
function _temp(s) {
  return s.isAuthenticated;
}